module.exports = __webpack_public_path__ + "static/media/cws5_banner_oloitem.c2cc5940.jpg";